export const GET_CURRENT_SOFTWARE = 'GET_CURRENT_SOFTWARE';


